import React from 'react'
import { Container, Image } from 'react-bootstrap'
import Whatsappicon from './components/Whatsappicon'
const Crs = () => {
	document.title="WSSL - CRS"
  return (
	< >
	<Whatsappicon />
<Container>
	<div style={{textAlign:"center"}}>
	<h1 className='text-center my-3'>COMPULSORY REGISTRATION SCHEME (CRS)</h1>
	<Image src='./Images/Brand/CRS R.jpg'  className='my-3'/>
	</div>

	<p>In 2012, the Compulsory Registration Scheme (CRS) was introduced by the Department of Electronics
	and Information Technology (Deity), jointly with the Bureau of Indian Standards (BIS), to protect Indians
	consumers from spurious and substandard goods. BIS Registration for Electronics and IT products comes
	under the compulsory registration scheme. As per this scheme, obtaining BIS registration certification for
	electronics and IT products is mandatory before launching them into the market.
	 </p>
	 <p>The Ministry also issued Compulsory Registration Orders, which state that no one shall manufacture or
	 store for sale, sell, import, or distribute goods that do not meet the Indian standards stipulated in the order
	 and do not bear the Standard Mark with a unique registration number. </p>
	</Container>
	</>
	)
}

export default Crs